<template>
  <div class="relative">
    <div
      class="cust-88per sm-full mx-auto lg:px-12 md:px-8 px-4 lg:mt-16 md:mt-12 mt-5"
    >
      <p
        class="title sm-fsize16 md:font-normal lg:font-normal font-bold lg:pl-2 md:pl-2 pl-6 mx-auto"
      >
        Announcements
      </p>
      <br />
      <br />
      <div class="">
        <swiper class="swiper sm-h-210px md-h-300px" :options="swiperOptions">
          <swiper-slide
            class="swiper sm-h-210px h-450px md-h-300px"
            v-for="item in get_AllhomeBanner"
            :key="item.objectId"
          >
            <div class="px-8">
              <a :href="item.link" target="_blank">
                <img
                  :src="hasError ? defaultImage : image(item.image)"
                  :alt="item.heading"
                  class="h-450px w-full rounded-xl lg:object-contain md:object-contain object-contain h-450px md-h-300px sm-h-210px"
                />
              </a>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev custarrow" slot="button-prev"></div>
          <div class="swiper-button-next custarrow" slot="button-next"></div>
          <div class="swiper-pagination cust-posi" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      hasError: false,
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
    };
  },

  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },

    async function() {
      let payload = "testing";
      await this.$store.dispatch("services/getallhomebanner");
      // console.log(this.get_AllhomeBanner);
    },
    image(x) {
      return `${this.$imageURL}/${x}`;
    },
  },

  computed: {
    ...mapState("services", { get_AllhomeBanner: "get_AllhomeBanner" }),
  },
  mounted() {
    this.function();
  },
};
</script>
<style lang="scss" scoped>
.cust-announce {
  position: initial !important;
  padding-top: 25px !important;
}
.cust-posi {
  position: initial !important;
  padding-top: 25px;
}
</style>
